import { Injectable, EventEmitter, Injector } from "@angular/core";
import { Api } from './api';
import { environment } from '../../environments/environment';
import { IStoreSettings } from '../../../../../common/common-interfaces/store-settings';
import { IGlobalSettings } from '../../../../../common/common-interfaces/global-settings';
import { IUser } from '../../../../../common/common-interfaces/user';




@Injectable()
export class Globals {
  //   storeName?: string;
  accessCode?: string;
  storeId?: string;
  storeSettings?: IStoreSettings;
  settings?: IGlobalSettings;
  adminKey: string;
  newFeatures: boolean = false;
  accessToken: string;
  currentUser: IUser;
  stores: IStoreSettings[];
  constructor(private injector: Injector) {

  }



  loadAdminKey() {
    this.adminKey = localStorage.getItem('adminKey');
  }

  setAdminKey(key: string) {
    console.log(`Setting admin key: ${key}`);
    this.adminKey = key;
    localStorage.setItem('adminKey', key);
  }

  panelUrl(url: string, storeSettings?: IStoreSettings) {
    if (!storeSettings && this.storeSettings)
      storeSettings = this.storeSettings;

    if (storeSettings)
      return this.storeUrl(url, storeSettings._id);
    //  return `/stores/${storeSettings.name}/${storeSettings.accessCode}/panel${url}`;
    return `/stores/${this.storeSettings.name}/${this.accessCode}/panel${url}`;
  }

  storeUrl(url: string, storeId?: string, absolute?: boolean) {
    let prefix = absolute ? '/admin' : '';
    if (storeId)
      return `${prefix}/store/${storeId}${url}`;

    return `${prefix}/store/${this.storeSettings._id}${url}`;
  }


  adminPanelUrl(url: string) {
    return `/panel${url}`;
  }


  userIsAce(){
    return this.adminKey || (this.currentUser && this.currentUser.role == 'ACE');
  }

  /**
   * Whether the Shopify dashboard theme should be used for the current user.
   * Superadmins can toggle this per user, otherwise it falls back to the
   * user being provisioned by the Shopify app.
   */
  useShopifyTheme() {
    if (!this.currentUser)
      return false;

    if (this.currentUser.settings && this.currentUser.settings.useShopifyTheme !== undefined)
      return !!this.currentUser.settings.useShopifyTheme;

    return this.currentUser.source == 'shopify';
  }

  applyUserTheme() {
    document.body.classList.toggle('shopify-user-theme', this.useShopifyTheme());
  }
}
